import styled from "styled-components";
import { DataGridHeading } from "@conserveit/blocks";

export const StyleDataGridHeading = styled(DataGridHeading)`
  justify-content: flex-end;
`;
